module.exports = __webpack_public_path__ + "assets/img/pic_117.a212c27b.png";